<template>
  <div class="container">
    <navigation/>
    <bigImage v-if="showBigImage"/>
    <div class="wrapper">
      <h3 v-if="category === 'lozasypialniane'">Łoża sypialniane</h3>
      <h3 v-else>{{category}}</h3>
      <div class="gridGallery">
      <div v-for="image in images" :key="image.id" class="single_image">
        <div @click="bigImage(image)" class="image" :style="`background-image: url('${image.url}')`"></div>
      </div>
      </div>
    </div>
       <div class="center">
      <router-link tag="button" class="backBtn" to="/imageGallery">Wróć do wyboru kategorii</router-link>
      </div>
    <Footer :class="{bottom: images.length === 0 }"/>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';
import navigation from '@/components/navigation.vue';
import Footer from '@/components/Footer.vue';
import bigImage from '@/components/bigImage.vue';
export default {
data(){
   return{
      category: this.$route.params.galleryCategory,
   }
  },
  components:{
    navigation, Footer, bigImage
  },
  computed:{
    ...mapState({
      images: state=>state.compress.bindedItems,
      showBigImage: state=>state.compress.showBigImage
    })
  },
  methods:{
    ...mapActions(['bindGalleryItems']),
    ...mapMutations(['bigImage'])
  },
  mounted(){
      this.bindGalleryItems(this.category);
  }
}
</script>

<style scoped lang="scss">
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
  cursor: pointer;
}
.image{
  background-position: center;
  background-size: cover;
  cursor: pointer;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.bottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
.wrapper{
  margin-top: 120px;
  width: 100%;
  flex-wrap: wrap;
  padding: 0 34px;
}
.gridGallery{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.single_image{
  margin: 6px 0;
}
.image{
  width: 300px;
  height: 300px;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
@media (min-width: 640px){
    .wrapper{
      padding: 0 100px;
    }
    .gridGallery{
      flex-direction: row;
      flex-wrap: wrap;
    }
    .image{
      margin: 3px 6px;
    }
}
</style>